/* eslint-disable */
import {
    first_login_step_1,
    first_login_step_2,
    first_login_step_3, first_login_step_4, first_login_step_5
} from "./courses/login/first_login";
import {
    patient_register_step_1,
    patient_register_step_2,
    patient_register_step_3
} from "./courses/user/inregistrare_pacient";

export const categories = [
    {
        id   : 'b32107e4-10ec-4d66-92bf-6f39262dde83',
        title: 'Fidelizare pacient',
        slug : 'fidelization',
        color: 'text-blue-800 bg-blue-100 dark:text-blue-50 dark:bg-blue-500'
    },
    {
        id   : '9a67dff7-3c38-4052-a335-0cef93438ff6',
        title: 'Autentificare',
        slug : 'login',
        color: 'text-blue-800 bg-blue-100 dark:text-blue-50 dark:bg-blue-500'
    },
    {
        id   : '9a67dff7-aaaa-4052-a335-0cef93438ff6',
        title: 'Administrare utilizatori',
        slug : 'user_mgmt',
        color: 'text-green-800 bg-green-100 dark:text-green-50 dark:bg-green-500'
    },
    {
        id   : '9a67dff7-bbbb-4052-a335-0cef93438ff6',
        title: 'Calendar',
        slug : 'calendar',
        color: 'text-pink-800 bg-pink-100 dark:text-pink-50 dark:bg-pink-500'
    },
    {
        id   : '9a67dff7-cccc-4052-a335-0cef93438ff6',
        title: 'Documentare clinica',
        slug : 'clinic_doc',
        color: 'text-amber-800 bg-amber-100 dark:text-amber-50 dark:bg-amber-500'
    },
    {
        id   : 'e8e6c91f-7921-4426-9d0d-72976d352ed2',
        title: 'Administrare clinica',
        slug : 'clinic_admin',
        color: 'text-amber-800 bg-amber-100 dark:text-amber-50 dark:bg-amber-500'
    },
];

export const courses = [
    {
        id         : "a7d011ed-dd53-4bca-bf54-6e316bd93810",
        title      : 'Calendar si programări',
        slug       : 'calendar',
        keywords   : 'cum unde creez gasesc caut editez modific schimb marchez vad sterg schimb adaug programare programari agenda calendar azi maine saptamana luna pentru pacient medic',
        description: 'Calendar medici si programări pentru pacient.',
        category   : 'calendar',
        bestForPages: ['calendar/clinic',"home/dashboard-medic"],
        duration   : { hours: 0, minutes: 10, seconds: 0 },
        totalSteps : 10,
        updatedAt  : 'Sept 2, 2026',
        featured   : true,
        progress   : {
            currentStep: 0,
            completed  : 0,
        },
    },
    {
        id         : '5a6912f1-9f10-4d6b-8e4f-521192b427f7',
        title      : 'Modul recall',
        slug       : 'fidelization',
        keywords   : 'cum unde chem creez anulez gasesc marchez vad sterg trimit sun schimb adaug recall chemare rechemare clinica sms email e-mail e mail telefon mesaj raspuns lista pacient expirat maturizat data feedback',
        description: 'Acest modul te va ajuta sa stapanesti rechemarile in clinica ta.',
        category   : 'fidelization',
        bestForPages: ['recall/clinic',"patients/patient/recall"],
        duration   : { hours: 0, minutes: 2, seconds: 37 },
        totalSteps : 13,
        updatedAt  : 'Apr 2, 2026',
        featured   : true,
        progress   : {
            currentStep: 0,
            completed  : 0,
        },
    },
    {
        id         : '522e087b-e20d-4605-8899-0ca1896f3cc9',
        title      : 'Lista de tratamente si afectiuni',
        slug       : 'clinic_admin', // user_mgmt  calendar  clinic_doc
        keywords   : 'cum unde creez gasesc editez modific schimb marchez vad sterg schimb adaug tratament tratamente afectiune afectiuni conditie conditii serviciu servicii produs produse lista clinica pacient pret preturi categorie recall cod de bare casa marcat',
        description: 'Zona de servicii si produse oferite de clinica.',
        category   : 'clinic_admin',
        bestForPages: ['admin/company-services',"/patients/patient/dental-chart"],
        duration   : { hours: 0, minutes: 3, seconds: 14 },
        totalSteps : 3,
        updatedAt  : 'Apr 2, 2026',
        featured   : true,
        progress   : {
            currentStep: 0,
            completed  : 0,
        },
    },
    // {
    //     id         : '694e4e5f-f25f-470b-bd0e-26b1d4f64028',
    //     title      : 'Prima logare/autentificare',
    //     slug       : 'login', // user_mgmt  calendar  clinic_doc
    //     description: 'Cum ne autentificam cu parola temporara',
    //     category   : 'login',
    //     duration   : { hours: 0, minutes: 2, seconds: 0 },
    //     totalSteps : 5,
    //     updatedAt  : 'Jun 28, 2021',
    //     featured   : true,
    //     progress   : {
    //         currentStep: 0,
    //         completed  : 0,
    //     },
    // },
    // {
    //     id         : '694e4e5f-f25f-470b-bd0e-26b1d4f6aaaa',
    //     title      : 'Inregistrare/creare pacient',
    //     slug       : 'user_mgmt',
    //     description: 'Cum cream/inregistram un nou pacient',
    //     category   : 'user_mgmt',
    //     duration   : { hours: 0, minutes: 2, seconds: 0 },
    //     totalSteps : 3,
    //     updatedAt  : 'Jun 28, 2021',
    //     featured   : true,
    //     progress   : {
    //         currentStep: 0,
    //         completed  : 0,
    //     },
    // },
];

export const courseSteps = new Map<string, any[]>([
    // [ "694e4e5f-f25f-470b-bd0e-26b1d4f64028",
    //         [
    //             {
    //                 order   : 0,
    //                 title   : 'Pasul 1 - Emailul automat',
    //                 subtitle: 'Identificare email trimis in mod automat',
    //                 content : `<h1 class="text-2xl sm:text-3xl">Prima logare</h1> ${first_login_step_1}`,
    //             },
    //             {
    //                 order   : 1,
    //                 title   : 'Pasul 2 - Parola temporara',
    //                 subtitle: 'Utilizare parola temporara primita pe email',
    //                 content : `<h1 class="text-2xl sm:text-3xl">Prima logare</h1> ${first_login_step_2}`,
    //             },
    //             {
    //                 order   : 2,
    //                 title   : 'Pasul 3 - Setare parola noua',
    //                 subtitle: 'Setarea noii parole',
    //                 content : `<h1 class="text-2xl sm:text-3xl">Prima logare</h1> ${first_login_step_3}`,
    //             },
    //             {
    //                 order   : 3,
    //                 title   : 'Pasul 4 - Autentificare',
    //                 subtitle: 'Autentificare cu noua parola',
    //                 content : `<h1 class="text-2xl sm:text-3xl">Prima logare</h1> ${first_login_step_4}`,
    //             },
    //             {
    //                 order   : 4,
    //                 title   : 'Felicitari',
    //                 subtitle: 'Curs finalizat',
    //                 content : `<h1 class="text-2xl sm:text-4xl">Felicitări!</h1> ${first_login_step_5}`,
    //             },
    //         ]
    // ],
    // [ "694e4e5f-f25f-470b-bd0e-26b1d4f6aaaa",
    //         [
    //             {
    //                 order   : 0,
    //                 title   : 'Pasul 1 - Accesare formular creare pacient',
    //                 subtitle: 'De unde cream un pacient. Cum acesam pagina de creare pacient.',
    //                 content : `<h1 class="text-2xl sm:text-3xl">Creare pacient</h1> ${patient_register_step_1}`,
    //             },
    //             {
    //                 order   : 1,
    //                 title   : 'Pasul 2 - Completare date pacient',
    //                 subtitle: 'Cum completam formularul de creare pacient.',
    //                 content : `<h1 class="text-2xl sm:text-3xl">Creare pacient</h1> ${patient_register_step_2}`,
    //             },
    //             {
    //                 order   : 2,
    //                 title   : 'Pasul 3 - Succes!',
    //                 subtitle: 'Primul pacient a fost adaugat.',
    //                 content : `<h1 class="text-2xl sm:text-3xl">Succes!</h1> ${patient_register_step_3}`,
    //             },
    //
    //
    //         ]
    // ],
    [ "5a6912f1-9f10-4d6b-8e4f-521192b427f7",
        [
            {
                order   : 0,
                title   : 'Ce este modulul de recall?',
                subtitle: 'Scopul modulului',
                content : ``,
                videoId: 'BHRYffPzZdE',
                duration: { hours: 0, minutes: 0, seconds: 19 }
            },
            {
                order   : 1,
                title   : 'Cum configurez perioada de recall pentru un tratament?',
                subtitle: 'Configurare perioada recall',
                content : ``,
                videoId: 'KmhOt66k00U',
                duration: { hours: 0, minutes: 0, seconds: 33 }
            },
            {
                order   : 2,
                title   : 'Cum creez un recall bazat pe tipul de tratament?',
                subtitle: 'Creare recall nou la finalizarea tratamentelor',
                content : ``,
                videoId: '4NWTtgOt_r8',
                duration: { hours: 0, minutes: 0, seconds: 37 }
            },
            {
                order   : 3,
                title   : 'Cum se creează recall-ul pentru vizita periodică?',
                subtitle: 'Creare recall vizita periodică',
                content : ``,
                videoId: 'rTRv3Zcx_SI',
                duration: { hours: 0, minutes: 0, seconds: 36 }
            },
            {
                order   : 4,
                title   : 'Cum vizualizez toate recall-urile clinicii?',
                subtitle: 'Rechemarile in clinică',
                content : ``,
                videoId: 'z-DMkXZPNBs',
                duration: { hours: 0, minutes: 0, seconds: 32 }
            },
            {
                order   : 5,
                title   : 'Cum vizualizez toate recall-urile unui pacient?',
                subtitle: 'Rechemarile unui pacient',
                content : ``,
                videoId: 'kSIc2KySbqw',
                duration: { hours: 0, minutes: 0, seconds: 19 }
            },
            {
                order   : 6,
                title   : 'Cum creez un recall personalizat?',
                subtitle: 'Rechemarile personalizat',
                content : ``,
                videoId: '0wWO7YCsM8M',
                duration: { hours: 0, minutes: 0, seconds: 21 }
            },
            {
                order   : 7,
                title   : 'Ce înseamnă că un recall s-a maturizat?',
                subtitle: 'Maturizare recall',
                content : ``,
                videoId: 'Sw8XAw2V4GA',
                duration: { hours: 0, minutes: 0, seconds: 24 }
            },
            {
                order   : 8,
                title   : 'Cum contactez pacientul pentru recall?',
                subtitle: 'Contactare pacient',
                content : ``,
                videoId: '9Mvr70eEH04',
                duration: { hours: 0, minutes: 0, seconds: 37 }
            },
            {
                order   : 9,
                title   : 'Cum contactez telefonic pacientul?',
                subtitle: 'Contactare pacient telefonic',
                content : ``,
                videoId: 'Iv-VWqhFYxs',
                duration: { hours: 0, minutes: 0, seconds: 37 }
            },
            {
                order   : 10,
                title   : 'Cum trimit un mesaj pentru recall?',
                subtitle: 'Contactare pacient sms/email',
                content : ``,
                videoId: 'Sq9zqlJqbNI',
                duration: { hours: 0, minutes: 0, seconds: 36 }
            },
            {
                order   : 11,
                title   : 'Cum marchez un recall ca finalizat sau eșuat?',
                subtitle: 'Feedback recall',
                content : ``,
                videoId: 'L9K27I_Xx94',
                duration: { hours: 0, minutes: 0, seconds: 29 }
            },
        ]
    ],
    [ "522e087b-e20d-4605-8899-0ca1896f3cc9",
        [
            {
                order   : 0,
                title   : 'Ce este sectiunea de servicii si produse?',
                subtitle: 'Scopul modulului',
                content : ``,
                videoId: 'dsveY5D0o5U',
                duration: { hours: 0, minutes: 0, seconds: 46 }
            },
            {
                order   : 1,
                title   : 'Cum creezi/editezi o conditie?',
                subtitle: 'Modificarea afectiunilor la nivel de clinica',
                content : ``,
                videoId: '3yBpfuh3xvU',
                duration: { hours: 0, minutes: 0, seconds: 46 }
            },
            {
                order   : 2,
                title   : 'Cum creezi/editezi un tratament?',
                subtitle: 'Modificarea tratamentelor la nivel de clinica',
                content : ``,
                videoId: 'tOm5xxkl2SQ',
                duration: { hours: 0, minutes: 1, seconds: 14 }
            },


        ]
    ],
        [ "a7d011ed-dd53-4bca-bf54-6e316bd93810",
            [
                {
                    order   : 0,
                    title   : 'Calendar și programări',
                    subtitle: 'Scopul modulului',
                    content : ``,
                    videoId: '-KwcJ_ECysg',
                    duration: { hours: 0, minutes: 1, seconds: 10 }
                },
                {
                    order   : 1,
                    title   : 'Cum adaug o programare?',
                    subtitle: 'Cum se adaugă programări noi din diferite ecrane',
                    content : ``,
                    videoId: 'xNcckQlezcc',
                    duration: { hours: 0, minutes: 1, seconds: 26 }
                },
                {
                    order   : 2,
                    title   : 'Cum reprogramez?',
                    subtitle: 'Cum modific data si ora unei programări existente',
                    content : ``,
                    videoId: 'NRUmj6UinJU',
                    duration: { hours: 0, minutes: 0, seconds: 37 }
                },
                {
                    order   : 3,
                    title   : 'Cum anulez o programare?',
                    subtitle: 'Anularea programării si notificarea pacientului',
                    content : ``,
                    videoId: 'KajH58S8EXM',
                    duration: { hours: 0, minutes: 0, seconds: 25 }
                },
                {
                    order   : 4,
                    title   : 'Confirmarea programării?',
                    subtitle: 'Ce înseamnă confirmarea programării, si cum se face',
                    content : ``,
                    videoId: 'qRrpLO1NWl4',
                    duration: { hours: 0, minutes: 1, seconds: 24 }
                },
                {
                    order   : 5,
                    title   : 'Cum configurez link urile de social media și recenzie?',
                    subtitle: 'Crește vizibilitatea online',
                    content : ``,
                    videoId: 'Kx9GMzjz8Gg',
                    duration: { hours: 0, minutes: 1, seconds: 24 }
                },
                {
                    order   : 6,
                    title   : 'Cum adaug concediu sau pauză?',
                    subtitle: 'Blocarea perioadelor din calendar',
                    content : ``,
                    videoId: 'UrcKUgwMr9g',
                    duration: { hours: 0, minutes: 1, seconds: 20 }
                },
                {
                    order   : 7,
                    title   : 'Cum folosesc căutarea avansata?',
                    subtitle: 'Găsești rapid slot liber in calendarul medicilor',
                    content : ``,
                    videoId: 'TJp75rwRC2I',
                    duration: { hours: 0, minutes: 1, seconds: 37 }
                },
                {
                    order   : 8,
                    title   : 'Cum schimb programul de lucru?',
                    subtitle: 'Configurare program de lucru',
                    content : ``,
                    videoId: '2xbLlpFWobk',
                    duration: { hours: 0, minutes: 1, seconds: 0 }
                },
                {
                    order   : 9,
                    title   : 'Cum personalizez culorile calendarului',
                    subtitle: 'Management categorii pentru evenimentele din calendar',
                    content : ``,
                    videoId: 'Tw1UH0eCn1w',
                    duration: { hours: 0, minutes: 1, seconds: 0 }
                },

            ]
        ]
]
);
